import { GlsPartner } from 'models/gls-partner.model';
import { UserProfile } from 'models/user-profile.model';

export const isBrowser = () => typeof window !== 'undefined';

export const getUser = (): UserProfile | undefined => {
  if (!isBrowser()) return undefined;

  const stored = window.sessionStorage.getItem('colisportUser');

  if (!stored || stored === 'undefined') return undefined;

  try {
    return JSON.parse(stored) as UserProfile;
  } catch {
    return undefined;
  }
};

export const setUser = (user?: UserProfile) => {
  if (!user) {
    window.sessionStorage.removeItem('colisportUser');
    return;
  }

  window.sessionStorage.setItem('colisportUser', JSON.stringify(user));
};

export const getToken = (): string => {
  if (!isBrowser()) return '';

  const stored = window.sessionStorage.getItem('authToken');

  if (!stored || stored === 'undefined' || stored === 'null') return '';

  return stored;
};

export const setToken = (token: string) => window.sessionStorage.setItem('authToken', token);

export const getGlsPartner = (): GlsPartner | undefined => {
  if (!isBrowser()) return undefined;

  const stored = window.sessionStorage.getItem('glsPartner');

  if (!stored || stored === 'undefined') return undefined;

  try {
    return JSON.parse(stored);
  } catch {
    return undefined;
  }
};
export const setGlsPartner = (glsPartner?: GlsPartner) => {
  if (!glsPartner) {
    window.sessionStorage.removeItem('glsPartner');
    return;
  }

  window.sessionStorage.setItem('glsPartner', JSON.stringify(glsPartner));
};

export const getHasGlsPartnerBenefits = (): boolean => {
  if (!isBrowser()) return false;
  return window.sessionStorage.getItem('hasGlsPartnerBenefits') === 'true';
};

export const setHasGlsPartnerBenefits = (value: boolean) => {
  if (!isBrowser()) return;
  window.sessionStorage.setItem('hasGlsPartnerBenefits', String(value));
};

export const logout = () => {
  window.sessionStorage.removeItem('colisportUser');
  window.sessionStorage.removeItem('authToken');
  window.sessionStorage.removeItem('glsPartner');
  window.sessionStorage.removeItem('hasGlsPartnerBenefits');
};
